import { Country } from '../constants'

interface Address {
  street?: string
  city?: string
  postalcode?: string
  state?: string
  latitude?: string
  longitude?: string
  geocodeAccuracy?: string
  country?: string
}

interface Contact {
  type?: string
  value?: string
}

interface CustomerProfile {
  id: number
  gid: string
  salutation: string
  firstName: string
  lastName: string
  gender: string
  email: string
  phoneNumber?: string
  mobilePhoneNumber?: string
  contacts?: Contact[]
  relations?: Relation[]
  country: Country
  dateOfBirth?: string
  firstSignUp?: string
  insertedAt?: string
  updatedAt?: string
  revision?: number
  source?: string
  lastModifiedBy?: string
  romanizedName?: string
  blocked?: false
  billingAddress?: Address
  shippingAddress?: Address
}

interface CustomerProfileRequest {
  anyRelationId?: string
}

enum RelationType {
  ACCOUNT = 'ACCOUNT',
  LEAD = 'LEAD',
}

interface Relation {
  id: number
  customerGid: string
  gid: string
  objectId: string
  objectSourceId: string
  type?: RelationType
  status?: string
  questionnaireCreditScore?: string
  sourceSystem?: string
  createdAt?: string
  insertedAt?: string
  lastModifiedBy?: string
  rejectReason?: string
  email?: string
  phone?: string
  mobilePhone?: string
  isPrimary?: boolean
}
export { RelationType }
export type { Address, CustomerProfile, CustomerProfileRequest, Relation }
